import React from 'react';
import { isNotEmpty } from "../util/user";
import algoliasearch from "algoliasearch";
import {Link} from 'react-router-dom';
import PropertyAlgolia from "./listings/PropertyAlgolia";

export default class NoMatch extends React.Component {
  constructor(props) {
    var client = algoliasearch('PTGN8U7BAB', '1bd38ecdf030101a4cff6d2447e8de2e');

    super(props);
    this.state = {
      results: [],
      loading: true,
      searchingFor: "",
      currentPage: 0,
      pageTotal: 10,
      pageSize: 50,
      client: client
    };

    this.Jobs = React.createRef();
    this.serverRequest = this.serverRequest.bind(this);
    this.searchJobs = this.searchJobs.bind(this);
  }

  serverRequest() {
    const page = this.state.page;
    const per_page = this.state.per_page;
    const state = this.state;

    fetch(`${process.env.REACT_APP_API_HOST}/api/jobs?page=${page}&per_page=${per_page}`)
    .then((response) => response.json())
    .then((json) => {
      this.setState({
        results: state.jobs.concat(json)
      });
    }).finally(() => this.setState({loading: false}))
  }

  searchJobs(e) {
    const search = e != undefined ? e.target.value.trim() : this.state.searchingFor;
    this.setState({ searchingFor: search });
    const state = this;

    // state.setState({loading: true});

    if (this.state.client !== undefined) {
      // var index = this.state.client.initIndex(process.env.REACT_APP_ALGOLIA,);

      const jobsQuery = {
        indexName: process.env.REACT_APP_ALGOLIA,
        params: {
          query: search,
          page: this.state.currentPage, // algolia starts at 0 for pages
          hitsPerPage: this.state.pageSize,
          attributesToRetrieve: '*',
          attributesToHighlight: [],
          facetFilters: []
        }
      };

      this.state.client.search([jobsQuery]).then((data) => {
        const results = (data.results[0].hits.reverse() || []).slice(0, this.state.pageSize);
        const stateResults = this.state.results;

        state.setState({loading: false});
        state.setState({results: stateResults.concat(results)})
        state.setState({pageTotal: data.results[0].nbPages})
      });
    }
  }

  componentDidMount() {
    this.searchJobs();
  }

  render() {
    let show;
    if (this.state.loading) {
      show = <div>Loading...</div>
    } else {
      show = <div className="row all-jobs-row">
        <div ref={this.Jobs} className="container" id="jobs-container">
          {this.state.results.map(function(job, index) {
            return (
              <span key={"job-result" + index} className="job-ctn">
                <PropertyAlgolia result={job} />
              </span>
            )
          })}
        </div>
      </div>
    }

    return (
      <div className="ctn-jobs">
        <div className="all-jobs white-bg">
          <div className="four-oh-four">
            <h3>404</h3>

            <p>Sorry, you’re lost, but let’s find you a house in <span className="yellow-font">Hamilton!</span></p>

            <p>Here’s some houses you might like.</p>
          </div>

          {show}
        </div>
      </div>
    )
  }
}
